import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { WebviewpagesPage } from './webviewpages';

@NgModule({
  declarations: [
    WebviewpagesPage,
  ],
  imports: [
    IonicPageModule.forChild(WebviewpagesPage),
  ],
  exports: [
    WebviewpagesPage
  ]
})
export class WebviewpagesPageModule {}



// WEBPACK FOOTER //
// ./src/app/shared/webviewpages/webviewpages.module.ts